module.exports = __webpack_public_path__ + "static/img/usc-logo.a3176e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usc-logo.png
// module id = B4ia
// module chunks = 1